import { InfoIcon } from '@phosphor-icons/react';
import styles from './VersionInfo.module.css';

interface VersionTriggerProps {
    placement: 'header' | 'footer';
    appName?: string;
    onClick: () => void;
}

export function VersionTrigger({ placement, appName, onClick }: VersionTriggerProps) {
    if (placement === 'footer') {
        return (
            <button
                type="button"
                className={styles.footerLink}
                onClick={onClick}
                aria-label={`Vis versjonsinformasjon og endringslogg${appName ? ` for ${appName}` : ''}`}
            >
                {appName ? `${appName} v${__APP_VERSION__}` : `v${__APP_VERSION__}`}
            </button>
        );
    }

    return (
        <button
            type="button"
            className={styles.headerButton}
            onClick={onClick}
            aria-label="Vis versjonsinformasjon og endringslogg"
        >
            <InfoIcon size={14} weight="regular" aria-hidden="true" />
            <span>v{__APP_VERSION__}</span>
        </button>
    );
}
